<template>
    <div class="form-horizontal">

        <div class="form-group">
            <label class="col-sm-2 control-label">1. Start Year</label>

            <div class="col-sm-6">
                <input class="form-control" type="number" min="1900" max="2100" v-model="startYear" />
            </div>
            <div class="col-sm-4 help-block">
                Select a start year for your pattern
            </div>
        </div>

        <div class="form-group">
            <label class="col-sm-2 control-label">2. Pattern</label>

            <div class="col-sm-6">
                <table class="table table-striped table-bordered">
                    <thead>
                    <tr>
                        <th>Year</th>
                        <th>Value</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(foo,index) in grid">
                        <th>{{ startYear + index }}</th>
                        <td><input type="number" step="any" class="form-control" v-model="foo.value"></td>
                        <td><i class="fa fa-trash-o" v-on:click="foo.value = ''"></i></td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-sm-4 help-block">
                <p>Enter at least 3 data points to continue.</p>
            </div>
        </div>

        <div class="form-group">
            <div class="col-xs-10 col-xs-offset-1">
                <button v-bind:class="{disabled: !isValid}" class="btn btn-block btn-primary" v-on:click="submit()">Use Pattern</button>
            </div>
        </div>

    </div>
</template>

<script>

    export default {

        data: function () {
            return {
                startYear: 2000,
                pattern: '',
                storage: storage,
                grid: [{value: ''}],
                title: 'Custom Pattern',
            };
        },

        watch: {
            grid: {
                handler: function () {
                    if (this.grid.length === 0
                        || this.grid[this.grid.length - 1].value !== ''
                    ) {
                        this.grid.push({value: ''});
                    }
                },
                deep: true,
            },
            storage: {
                handler: function () {
                    let items = this.storage.pattern.split("\n");
                    this.startYear = parseInt(items[0].split(",")[0].substring(0,4));
                    this.grid = items.map(function (item) {
                        return {value: item.split(',')[1]};
                    });
                },
                deep: true,
            },

        },

        computed: {
            isValid: function () {
                return this.grid.length > 3;
            },
            pattern: function () {
                let list = [];
                for (let i = 0; i < this.grid.length - 1; i++) {
                    list.push(this.startYear + i + ',' + this.grid[i].value)
                }
                return list.join("\n");
            }
        },

        methods: {
            submit: function () {
                this.storage.updateTitle('Custom Pattern');
                this.storage.updatePattern(this.pattern);
                //this.$root.$emit('nextStep', 'review');
            }
        }

    }

</script>